import React, { type PropsWithChildren, type ReactNode, type MouseEvent, useRef, useState } from "react";
import clsx from "clsx";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "./SectionCollapse.module.scss";

export type Props = {
    summary: ReactNode;
    onChange?: (isOpen: boolean) => void;
    fullContentWidth?: boolean;
} & Omit<React.HTMLProps<HTMLDetailsElement>, "summary">;

const Collapse: React.FC<PropsWithChildren<Props>> = (props) => {
    const { summary, children, open, fullContentWidth, className, ...rest } = props;
    const [internalIsOpen, setInternalIsOpen] = useState(open ?? false);
    const contentRef = useRef<HTMLDivElement>(null);

    const toggleOpen = (event: MouseEvent<HTMLDetailsElement>): void => {
        event.preventDefault();
        setInternalIsOpen(!internalIsOpen);
        props.onChange?.(!internalIsOpen);
    };

    return (
        <details open={open ?? internalIsOpen} {...rest} className={clsx(styles.details, className)}>
            <summary onClick={toggleOpen}>
                <Text tag="span" variant="apheleia-h5">
                    {summary}
                </Text>
                <Icon variant="minus" sizing="sm" className={styles["close-icon"]} aria-hidden="true" />
                <Icon variant="plus" sizing="sm" className={styles["open-icon"]} aria-hidden="true" />
            </summary>
            <div className={clsx(styles.content, fullContentWidth && styles.fullwidth)} ref={contentRef}>
                {children}
            </div>
        </details>
    );
};

export default Collapse;
